<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onUpdate">
    <v-card tile>
      <v-card-title class="grey lighten-2">Redigera ersättning</v-card-title>
      <v-card-text class="mt-2">
        <v-row>
          <ReplacementTypeField />
          <v-col>
            <v-text-field
              label="Tågnummer"
              outlined
              type="number"
              :disabled="model.type === 'SHUTTLE'"
              :rules="[model.type !== 'SHUTTLE' ? required : () => true]"
              v-model.number="model.train_number"
            />
          </v-col>
        </v-row>

        <ReplacementFromToField />
        <ReplacementViaField />
        <ReplacementStatusField />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="updatePending"
          >Redigera försening</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required } from '@/common/validationRules'
import ReplacementTypeField from './ReplacementForm/ReplacementTypeField'
import ReplacementStatusField from './ReplacementForm/ReplacementStatusField'
import ReplacementFromToField from './ReplacementForm/ReplacementFromToField'
import ReplacementViaField from './ReplacementForm/ReplacementViaField'

export default {
  name: 'ReplacementEditModal',

  components: {
    ReplacementTypeField,
    ReplacementStatusField,
    ReplacementFromToField,
    ReplacementViaField
  },

  props: {
    item: Object
  },

  data: () => ({
    required,
    valid: true,
    updatePending: false
  }),

  created() {
    const updateModel = Object.keys(this.model).reduce((acc, key) => {
      if (key === 'uuid') {
        acc[key] = this.model[key]
      } else {
        acc[key] = this.item[key]
      }
      return acc
    }, {})

    this.$store.set('replacement/model', updateModel)
  },

  computed: {
    model: sync('replacement/model')
  },

  methods: {
    async onUpdate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.updatePending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: ReplaceReplacementInput!) {
            replaceReplacement(payload: $payload) {
              replacement_uuid
            }
          }
        `,
        variables: {
          payload: {
            delete_uuid: this.item.uuid,
            payload: this.model
          }
        }
      })

      this.updatePending = false
      this.$store.set(`replacement/data@${this.item.uuid}.deleted`, true)
      this.$store.set(`replacement/data@${this.model.uuid}`, this.model)
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('replacement/resetModel')
      this.$emit('close')
    }
  }
}
</script>
